/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as ROUTES from '@constants/routes';

export enum ManageAccountMenuRoute {
  // @ts-ignore isolated modules error
  ProfileSecurity = ROUTES.MANAGE_PROFILE,
  // @ts-ignore isolated modules error
  PaymentBilling = ROUTES.MANAGE_SUBSCRIPTION,
  // @ts-ignore isolated modules error
  Consents = ROUTES.MANAGE_CONSENTS,
  // @ts-ignore isolated modules error
  AccessManagement = ROUTES.MANAGE_ACCESS_MANAGEMENT,
  // @ts-ignore isolated modules error
  Notifications = ROUTES.MANAGE_NOTIFICATIONS,
  // @ts-ignore isolated modules error
  Alerts = ROUTES.MANAGE_ALERTS,
  // @ts-ignore isolated modules error
  Plan = ROUTES.MANAGE_PLAN,
  // @ts-ignore isolated modules error
  Settings = ROUTES.MANAGE_SETTINGS,
  // @ts-ignore isolated modules error
  Appearance = ROUTES.MANAGE_APPEARANCE,
}

export const AccountMenuItemProperties: Record<
  ManageAccountMenuRoute,
  {
    display: string;
    subtitle?: string;
  }
> = {
  [ManageAccountMenuRoute.ProfileSecurity]: {
    display: 'manageAccount.profileAndSecurity',
    subtitle: 'manageAccount.securitySubtitle',
  },
  [ManageAccountMenuRoute.PaymentBilling]: {
    display: 'manageAccount.paymentBilling',
    subtitle: 'manageAccount.paymentSubtitle',
  },
  [ManageAccountMenuRoute.Consents]: {
    display: 'manageAccount.consents',
    subtitle: 'manageAccount.consentSubtitle',
  },
  [ManageAccountMenuRoute.AccessManagement]: {
    display: 'manageAccount.accessManagement',
    subtitle: 'manageAccount.accessManagementSubtitle',
  },
  [ManageAccountMenuRoute.Notifications]: {
    display: 'manageAccount.notifications',
    subtitle: 'manageAccount.notificationSubtitle',
  },
  [ManageAccountMenuRoute.Alerts]: {
    display: 'manageAccount.alerts',
    subtitle: 'manageAccount.alertSubtitle',
  },
  [ManageAccountMenuRoute.Plan]: {
    display: 'manageAccount.plan',
    subtitle: 'manageAccount.planSub',
  },
  [ManageAccountMenuRoute.Settings]: {
    display: 'manageAccount.settings',
  },
  [ManageAccountMenuRoute.Appearance]: {
    display: 'manageAccount.appearance',
  },
};
